import { Component, EventEmitter, HostListener, Input, Output, ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'app-modal-dialog',
  templateUrl: './modal-dialog.component.html',
  styleUrls: ['./modal-dialog.component.scss']
})
export class ModalDialogComponent {
  @Input() title: string = 'Título';
  @Input() show: boolean = false;
  @Input() showHeader: boolean = false;
  @Input() showFooter: boolean = false;
  @Input() size: 'sm' | 'md' | 'lg' | 'xl' | 'xxl' | 'full' | 'auto' = 'auto'; // Tamaño flexible
  @Input() position: 'center' | 'top' = 'center';       // Ubicación

  @Output() closed = new EventEmitter<void>();
  @Output() confirmed = new EventEmitter<void>();

  onClose() {
    this.show = false;
    this.closed.emit();
  }

  onConfirm() {
    this.show = false;
    this.confirmed.emit();
  }

  // Escucha global de la tecla Escape
  @HostListener('document:keydown.escape', ['$event'])
  onEscape(event: KeyboardEvent) {
    if (this.show) {
      event.preventDefault();
      this.onClose();
    }
  }
}
